<div *hasScope="SCOPES.USERS.READ_ALL">
  <div class="flex flex-col gap-4">
    <div class="flex items-center justify-between">
      <h1 class="titleColor text-2xl font-bold" i18n="@@departmentListTitle">Departments</h1>

      <a
        routerLink="/admin/departments/create"
        class="bgPrimaryColor hover:bgHoverPrimaryColor flex items-center gap-2 rounded-md px-4 py-2 text-sm font-medium text-white transition-colors hover:cursor-pointer">
        <app-add-icon />
        <span i18n="@@departmentCreateNew">Create New Department</span>
      </a>
    </div>

    <app-departments-list-filter
      [filters]="filters()"
      (applyFilters)="onApplyFilters($event)"
      (resetFilters)="onResetFilters()"
      (sortChange)="onSortChange($event)" />

    @if (loading()) {
      <app-loading />
    } @else if (errorGettingDepartments()) {
      <app-error-data [title]="errorGettingDepartments()!" [showRetry]="true" (retry)="loadDepartments()" />
    } @else {
      <app-tables
        [headerItems]="tableHeaders()"
        [rows]="tableRows()"
        [currentActions]="tableActions()"
        [scopeResolver]="departmentScopeResolver"
        [isFiltersApplied]="isFiltersApplied()"
        [emptyFilterTitle]="emptyFilterTitle()"
        [emptyContentTitle]="emptyContentTitle"
        [emptyContentDescription]="emptyContentDescription"
        (actionTrigger)="onActionTriggered($event)" />
    }

    @if (totalItems() > 0) {
      <app-pagination
        [itemsPerPage]="itemsPerPage()"
        [currentPage]="currentPage()"
        [getPageNumbers]="getPageNumbers()"
        [totalPages]="totalPages()"
        [startItem]="startItem()"
        [endItem]="endItem()"
        [totalItems]="totalItems()"
        (previousPage)="previousPage()"
        (nextPage)="nextPage()"
        (goToPage)="goToPage($event)"
        (changePageNumber)="onPageSizeChange($event)" />
    }

    @if (showSuccessMessage()) {
      <app-successful-notification
        type="success"
        title="Department ‘{{
          deletedDepartmentName() // i18n(ph='departmentName')
        }}’ deleted successfully"
        i18n-title="@@departmentDeletedSuccessfully" />
    }

    @if (isDeleteDialogOpen()) {
      <app-confirmation-dialog
        layout="start"
        title="Delete Department"
        i18n-title="@@departmentDeleteDialogTitle"
        description="Are you sure you want to delete"
        i18n-description="@@departmentDeleteDialogDescription"
        [itemName]="deleteDialogItemName()"
        [confirmContent]="deleteLoading() ? (isArabic() ? 'تحميل...' : 'Loading...') : isArabic() ? 'حذف' : 'Delete'"
        cancelContent="Cancel"
        i18n-cancelContent="@@departmentCancel"
        [error]="deleteError()"
        (onCancel)="onCancelDelete()"
        (onSubmit)="onDeleteDialogSubmit()" />
    }
  </div>
</div>
